export default __webpack_public_path__ + "static/media/sun.432c43fb.svg";